module.exports = __webpack_public_path__ + "static/media/Residential_60.72f7b3ef.jpg";